import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as StocksActions from '../actions/stocks.actions';
import {
  catchError,
  concatMap,
  delay,
  map,
  of,
  switchMap,
  withLatestFrom,
} from 'rxjs';
import { StocksSelectors } from '../selectors/stocks.selectors';

@Injectable({
  providedIn: 'root',
})
export class StocksEffects {
  constructor(
    private actions$: Actions,
    private stocksSelectors: StocksSelectors
  ) {}

  // getUser$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(initActions.getUser),
  //     switchMap((action) => {
  //       return this.initService.getUser(action.userId).pipe(
  //         //  delay(1000),
  //         map((accountInfo: AccountInfo) => {
  //           return initActions.getUserSuccess({ accountInfo });
  //         }),
  //         catchError(() => of(initActions.getUserError()))
  //       );
  //     })
  //   )
  // );
}
